import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { TEXT_FILTER } from "../constants/busqueda/text-filter-constants";
import { IBusquedaDocumento } from "../models/busqueda/busqueda-documento.model";
import { ISelectedFilter } from "../models/busqueda/selected-filter.model";
import { SigedCommonService } from "../siged-common.service";
import { AuthService } from "./auth.service";

@Injectable({
    providedIn: 'root'
})
export class BusquedaAvanzadaService {
    generalSearch$ = new BehaviorSubject<string>(null);
    origenSearch$ = new BehaviorSubject<string>(null);
    searchTitle$ = new BehaviorSubject<string>(null);
    inputsFilter$ = new BehaviorSubject<ISelectedFilter[]>([]);
    clearInputFilter$ = new Subject<ISelectedFilter>();
    clearAllFilters$ = new Subject<boolean>();
    searchDocumento$ = new Subject<boolean>();
    activeDetail = false;
    documento: IBusquedaDocumento = {};
    private defaultHeaders;
    private baseUrl = this.mpvCommonService.APPLICATION_API_HOST;
    constructor(
        private http: HttpClient,
        private authService: AuthService,
        private mpvCommonService: SigedCommonService
    ) {
        this.defaultHeaders = {
            Authorization: 'Bearer ' + this.authService.getUser()
        }
    }

    removeItemInputFilter(item: ISelectedFilter): void {
        const inputsFilter = this.inputsFilter$.value;
        const newInputFilter = inputsFilter.filter(f => {
            if (f.key === TEXT_FILTER.textEtiqueta && f.id !== item.id) {
                return f;
            } else if (f.key !== item.key) {
                return f;
            }
        });
        this.inputsFilter$.next(newInputFilter);
        this.clearInputFilter$.next(item);
    }

    buscarDocumentos(
        params: HttpParams | { [param: string]: string | string[] },
        body: any,
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ): Observable<any> {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.post(`${this.baseUrl}/busqueda/documentos`, body, options);
    }

    buscarDocumentosEmitidos(
        params: HttpParams | { [param: string]: string | string[] },
        body: any,
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ): Observable<any> {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.post(`${this.baseUrl}/busqueda/documentosEmitidos`, body, options);
    }

    buscarRegistros(
        body: any,
        params: { page: string, size: string, order: string },
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ): Observable<any> {
        const options = { params, headers: { ... this.authService.getDefualtHeaders(), ...headers } }
        return this.http.post(`${this.baseUrl}/busqueda/expedientes`, body, options);
    }

    watchInputsFilterState() {
        return this.inputsFilter$.asObservable()
    }

    setInputFilters(data: ISelectedFilter[]) {
        this.inputsFilter$.next(data);
    }

    async addInputsFilter(data: ISelectedFilter) {
        const allInputs = await this.watchInputsFilterState().toPromise()
        const exists = allInputs.filter(i => i.key == data.key).length
        if (!exists) this.setInputFilters([...allInputs, data])
    }

}
